"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setDesiredLocale;

var _config = require("../../config");

var _getSupportedLocales = _interopRequireDefault(require("./getSupportedLocales"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setDesiredLocale(desiredLocale) {
  var supportedLocales = (0, _getSupportedLocales.default)();
  if (!supportedLocales.includes(desiredLocale)) return;
  localStorage.setItem(_config.STORAGE_KEY_DESIRED_LOCALE, desiredLocale);
}